import React, { useCallback, useEffect } from "react"
import { SubscriptionFeature } from "../types/membership/membershipTypes"
import { toValidNumber } from "../utils/helpers";
import { Link } from "react-router-dom";
import Badge from "../components/badges/Badge";
import MembershipSkeleton from "../skeletons/MembershipSkeleton";
import { AppDispatch, RootState } from "../redux-stores/store";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchMembershipData } from "../redux-stores/slices/membershipSlice";

const Membership: React.FC = () => {

    const dispatch:AppDispatch = useDispatch();

    const {loading, active_plan: activePlan, subscription_features: subscriptionFeatures} = useSelector((state: RootState) => state.membership);
    
    const fetchData = useCallback(async (force=false) => {
        dispatch(fetchMembershipData(force))
    }, [dispatch])

    useEffect(() => {
        fetchData();
    }, [fetchData])

    if (loading) return <MembershipSkeleton />

    return (
        <div className="card card-style py-2 position-relative">
            <div className="content">
                {/* <img src="images/undraw/1.svg" width="250" className="mx-auto" /> */}
                <h1 className="text-center pt-3 font-30 mb-2 pop">{activePlan?.plan?.name}</h1>
                {/* <p className="text-center color-highlight font-600"></p> */}
                {
                    activePlan?.platform &&
                    <React.Fragment>
                        <div className="divider"></div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex flex-column">
                                {
                                    activePlan?.platform &&
                                    <React.Fragment>
                                        <span className="text-gray-500">Started:</span>
                                        <span className="text-gray-900">{activePlan.started_date}</span>
                                    </React.Fragment>
                                }
                            </div>
                            <h1 className="font-40 text-center">
                                <sup className="price-sup font-22">₹</sup>
                                {toValidNumber(activePlan?.billing_amount)}
                                {/* <sup className="price-sup font-14">.99</sup> */}
                            </h1>
                            <div className="d-flex flex-column justify-content-end align-items-end">
                                {
                                    activePlan?.platform &&
                                    <React.Fragment>
                                        <span className="text-gray-500">Next Due:</span>
                                        <span className="text-gray-900">{activePlan.next_due_date}</span>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </React.Fragment>
                }


            </div>
            <div className="table-responsive px-3 ">
                <table className="table align-middle table-row-dashed o">
                    <thead>
                        <tr className="border-bottom">
                            <th>Feature</th>
                            <th className="text-end">Usage</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            subscriptionFeatures && Object.values(subscriptionFeatures).map((sf: SubscriptionFeature, i: number) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            <label>{sf.name}</label>
                                            <div>{sf.description}</div>
                                        </td>
                                        <td className="text-end">
                                            {
                                                sf.type === 'consumable' &&
                                                <span>{sf.consumed_limit}/{sf.applicable_limit}</span>
                                            }
                                            {
                                                sf.type !== 'consumable' &&
                                                <React.Fragment>
                                                    {
                                                        sf.applicable_limit ? <i className="fa fa-check-circle color-green-dark"></i> : <i className="fa fa-times-circle color-red-dark"></i>
                                                    }
                                                </React.Fragment>
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-center pb-2">
                <Link to='/i/pricing' className="btn w-100 mx-3 btn-primary text-center rounded-sm btn-sm">Upgrade</Link>
            </div>
            <div className=" position-absolute" style={{ left: "6px" }}>
                <Badge variant="highlight" size="lg">Current Plan</Badge>
            </div>
        </div>
    )
}

export default Membership